/* eslint-disable no-restricted-imports */
import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { AEMetadata } from "../../../_emywork/AEPagination";
import { useLang } from "../../../_metronic/i18n";
import { ModalProgressBar } from "../../../_metronic/_partials/controls";

export function DeleleteLayout({
  modalTitle,
  CONTEXT,
  useModuleContext,
  actions,
  actionTypes,
  metadata,
  CONTEXT_TITLE,
  history,
}) {
  const { formatMessage, formatHTMLMessage } = useIntl();
  const lang = useLang();
  const {
    value: { deleteModalShow, closeDeleteDialog, idForDelete },
  } = useModuleContext();
  const dispatch = useDispatch();
  const { isLoading, entity } = useSelector(
    (s) => s[CONTEXT].deleteDialog,
    shallowEqual
  );
  useEffect(() => {
    if (!idForDelete) closeDeleteDialog();
    else {
      dispatch(
        actions.fetchEntity(
          idForDelete,
          new AEMetadata(metadata),
          actionTypes.Delete
        )
      );
    }
  }, [idForDelete, dispatch]);

  // looking for loading/dispatch
  useEffect(() => {}, [isLoading, dispatch]);

  const deleteEntity = () => {
    dispatch(actions.deleteEntity(idForDelete)).then(() => {
      dispatch(actions.fetchEntities(new AEMetadata(metadata)));
      closeDeleteDialog();
    });
  };

  return (
    <Modal
      show={deleteModalShow}
      onHide={closeDeleteDialog}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {isLoading && <ModalProgressBar variant="query" />}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          {modalTitle}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isLoading && entity && (
          <span
            dangerouslySetInnerHTML={{
              __html: formatHTMLMessage(
                { id: "DIALOG.DELETE.MESSAGE" },
                { name: "this entry" }
              ),
            }}
          />
        )}
        {isLoading && <span>{CONTEXT_TITLE.singular} is deleting...</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={closeDeleteDialog}
            className="btn btn-light btn-elevate"
          >
            {formatMessage({ id: "CANCEL" })}
          </button>
          <> </>
          <button
            type="button"
            onClick={deleteEntity}
            className="btn btn-delete btn-elevate"
          >
            {formatMessage({ id: "DELETE" })}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
